export const list = {
  unset: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
};
